import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/Login.vue';
import Customer from '@/views/Customer.vue';

import { RESET_AUTH, SET_TABLE_DIALOG, SET_DRAWER } from '@/store/mutation-types';
const { $gettext } = Vue.prototype;

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'customer',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: $gettext('Login'),
        requiresAuth: false,
      },
    },
    {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: {
        title: $gettext('Customer'),
      },
    }
  ],
});

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${Vue.prototype.$gettext(to.meta.title)}`;

  if (to.matched.some(
    record => typeof (record.meta.requiresAuth) === 'undefined' || record.meta.requiresAuth !== false,
  )) {
    const { store } = Vue.prototype;
    store.commit(RESET_AUTH);
    if (store.state.auth.token === '') {
      next({
        name: 'login',
        params: { nextUrl: to.fullPath },
      });
    } else {
      store.commit(SET_TABLE_DIALOG, false);
      store.commit(SET_DRAWER, true);
      next();
    }
  } else {
    next();
  }

});

export default router;
